import React from "react";
import {Tooltip} from "../common/Tooltip";
import "./DropMenu.css";

type DropMenuProps = {
    containerClassName?: string;
    tooltip?: string;
    disabled?: boolean;
    label: string;
    onChange?: (menu_name: string, e: React.MouseEvent<HTMLElement>) => void;
    children?: React.ReactNode;
}

export const DropMenu = (props: DropMenuProps) => {

    const [showMenu, setShowMenu] = React.useState(false);

    const handleShow = (e: React.MouseEvent<HTMLElement>) => {
        if (props.disabled !== true) {
            setShowMenu(true);
        }
    }
    const handleClose = () => {
        setShowMenu(false);
    }
    const handleChildrenClick = (e: React.MouseEvent<HTMLElement>) => {
        if (e.target instanceof HTMLElement) {
            const menu_name = e.target.dataset.drop_menu;
            if (menu_name !== undefined) {
                props.onChange?.(menu_name, e);
            }
        }
        handleClose();
    }

    return (
        <div className={"drop_menu-container " + props.containerClassName} onClick={e => e.preventDefault()}>
            <Tooltip title={props.tooltip || ''}>
                <div className={"drop_menu-label-area"} aria-disabled={props.disabled} onClick={handleShow}>
                    <span className={"drop_menu-label"}>{props.label}</span>
                    <span className={"drop_menu-marker"}>&nbsp;</span>
                </div>
            </Tooltip>
            {props.disabled !== true && showMenu && (
                <div className="drop_menu-popover" onClick={handleChildrenClick}>
                    <div className="drop_menu-cover" onClick={handleClose}/>
                    {props.children}
                </div>
            )}
        </div>
    );
}
